module.exports = __webpack_public_path__ + "src/assets/graphical_view_on.png";